import script from "./BulkTemplateManager.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkTemplateManager.vue?vue&type=script&setup=true&lang=js"

import "./BulkTemplateManager.vue?vue&type=style&index=0&id=47f17dc3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47f17dc3"]])

export default __exports__